import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "hotspot-content__container" }
const _hoisted_2 = { class: "hotspot-content__left-col" }
const _hoisted_3 = { class: "hotspot-content__media-container" }
const _hoisted_4 = {
  key: 0,
  class: "embed-responsive embed-responsive-16by9"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  id: "player",
  class: "embed-responsive-item"
}, null, -1 /* HOISTED */)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "hotspot-content__media-thumbs" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["src", "alt", "onClick"]
const _hoisted_11 = {
  key: 1,
  class: "embed-responsive embed-responsive-16by9"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  id: "mobileplayer",
  class: "embed-responsive-item"
}, null, -1 /* HOISTED */)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["src", "alt", "onClick"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "fa-solid fa-chevron-left" }, null, -1 /* HOISTED */)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "fa-solid fa-chevron-right" }, null, -1 /* HOISTED */)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "hotspot-content__right-col" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = {
  key: 1,
  class: "hotspot-content__logos-container animate__animated animate__fadeIn"
}
const _hoisted_22 = { class: "hotspot-content__logos-col" }
const _hoisted_23 = ["src", "alt"]
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = {
  key: 3,
  class: "mt-4 animate__animated animate__fadeIn"
}
const _hoisted_26 = {
  key: 0,
  class: "fas fa-external-link ml-1"
}
const _hoisted_27 = { class: "hotspot-content__pager" }

import {onMounted, reactive, computed, ref, watch, nextTick} from 'vue';
import {Hotspot, HotspotPlacement} from "Interfaces/Interfaces";
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';

import { v4 as uuidv4 } from 'uuid';
declare let YT: any;
declare global {
	interface Window {
		onYouTubeIframeAPIReady?: () => void;
	}
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalHotspot',
  props: {
	placement: {
		type: Object as () => HotspotPlacement,
		default: () => ({})
	},
	hotspotItem: {
		type: Object as () => Hotspot,
		default: () => ({})
	},
	activeHotspotIndex: {
		type: Number,
		default: 0
	},
	placementsLength: {
		type: Number,
		default: 0
	},
	index: {
		type: Number,
		default: 0
	}
},
  emits: ['updateActiveHotspotIndex'],
  setup(__props, { emit: __emit }) {

const activeElement = reactive({
	type: '',
	passedValue: '',
	alt: ''
});

const modules = [Navigation];
const isDesktop = ref<boolean>(false);
const uniqueId = uuidv4();
const swiperOptions = {
	0: {
		slidesPerView: 1,
		spaceBetween: 10
	},
	768: {
		slidesPerView: 3,
		spaceBetween: 10
	},
};
const activeSwiperSlideIndex = ref<number>(0);
const swiperInstance = ref<any>(null);
const swiperLeft = ref(null);
const youtubePlayer = ref(null);
const swiperRight = ref(null);
const player = ref(null);
const swiperKey = ref(0);
const swiperInit = (swiper) => {
	swiperInstance.value = swiper;
};

const isDesktopBreakpoint = computed(() => {
	return isDesktop.value || matchMedia('(min-width: 768px)').matches;
});

const emit = __emit;
const props = __props;

//Comps show a 0 in front of single digit numbers, this adds the zero if less than 10
const zeroInFront = (number) => {
	if (number < 10) {
		return '0' + number;
	}
	return number.toString(); // Convert to string if it's not a single digit
}

// This runs when pager previous button is clicked and sets it back 1 hotspot
const goToPreviousIndex = (index) => {
	if (index !== 0) {
		emit('updateActiveHotspotIndex', index - 1);
	}
};

const breakpointChange = (swiper) => {
	let windowWidth = window.innerWidth;
	isDesktop.value = windowWidth > 767;

	if(isDesktopBreakpoint.value) {
		setActiveElement(combinedHotspotImagesAndVideos.value[0], 0);
	} else {
		slideChange(swiper);
	}
}

// This runs when the page next button is clicked and sets the index forward one
const goToNextIndex = (index) => {
	if ((index + 1) < props.placementsLength) {
		emit('updateActiveHotspotIndex', index + 1);
	}
};

//combines videos and images into one array
const combinedHotspotImagesAndVideos = computed(() => {
	let combinedMediaElements = [];
	if(props?.hotspotItem?.HotspotVideos?.length) {
		combinedMediaElements = [ ...combinedMediaElements, ...props.hotspotItem?.HotspotVideos];
	}
	if(props?.hotspotItem?.HotspotImages?.length) {
		combinedMediaElements = [ ...combinedMediaElements, ...props.hotspotItem?.HotspotImages];
	}

	return combinedMediaElements;
});

//This function sets the active element when the swiper slide is changed at mobile
const slideChange = (swiper) => {
	if (!isDesktopBreakpoint.value) {
		let el = combinedHotspotImagesAndVideos.value[swiper.activeIndex];
		if (player.value) {
			// If there is an existing player instance, stop and destroy it
			player.value.destroy();
			player.value = null; // Ensure player is nullified
		}
		if(el.hasOwnProperty('YouTubeID')) {
			activeElement.type = 'video';
			activeElement.passedValue = el.YouTubeID;
			activeElement.alt = '';
			createYoutubePlayer(activeElement.passedValue, 'mobileplayer');
		} else {
			activeElement.type = 'image';
			activeElement.passedValue = el.ImageUrl;
			activeElement.alt = el.AltText;
		}

		activeSwiperSlideIndex.value = swiper.activeIndex;
	}
};


//This function sets the active element when a swiper slide is clicked at desktop
const setActiveElement = (el, index) => {
	if(isDesktopBreakpoint.value) {
		if(combinedHotspotImagesAndVideos.value[index].hasOwnProperty('YouTubeID')) {
			activeElement.type = 'video';
			activeElement.passedValue = el.YouTubeID;
			activeElement.alt = '';
			if (player.value) {
				// If there is an existing player instance, stop and destroy it
				player.value.destroy();
				player.value = null; // Ensure player is nullified
			}
			createYoutubePlayer(activeElement.passedValue, 'player');
		} else {
			activeElement.type = 'image';
			activeElement.passedValue = el.ImageUrl;
			activeElement.alt = el.AltText;
		}
		activeSwiperSlideIndex.value = index;
	}
}

//this makes the button go to the correct page when clicked keeping in mind new window or not
const goToUrl = (path, newWindow) => {
	if(newWindow === 'True') {
		window.open(path, '_blank');
	} else {
		window.location.href = path;
	}
};

//This function sets the intial active item (big picture/video) when the page loads and when its updated
const setInitialActiveElement = () => {
	if(combinedHotspotImagesAndVideos.value?.length) {
		if(combinedHotspotImagesAndVideos.value[0].hasOwnProperty('YouTubeID')) {
			activeElement.type = 'video';
			activeElement.passedValue = props.hotspotItem?.HotspotVideos[0]?.YouTubeID;
			activeElement.alt = '';

			//isDesktop is set to false initially and doesnt get rechecked until swiper initializes so use match media as well
			if(isDesktopBreakpoint.value) {
				createYoutubePlayer(activeElement.passedValue, 'player');
			} else {
				createYoutubePlayer(activeElement.passedValue, 'mobileplayer');
			}
		} else {
			activeElement.type = 'image';
			activeElement.passedValue = props.hotspotItem?.HotspotImages[0]?.ImageUrl;
			activeElement.alt = props.hotspotItem?.HotspotImages[0]?.AltText;
		}
		activeSwiperSlideIndex.value = 0;
	}
}

// Check if the API script has already been loaded, if not inject it in
const injectYoutubePlayerAPIScript = () => {
	if (typeof YT === 'undefined' || typeof YT.Player === 'undefined') {
		// Load the IFrame Player API code asynchronously if not loaded already
		let tag = document.createElement('script');
		tag.src = "https://www.youtube.com/iframe_api";
		let firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	}
}

watch(() => props.activeHotspotIndex, (oldValue, newValue) => {
	swiperKey.value++;
});

const playVideo = (event) => {
	player.value.playVideo();
}


const createYoutubePlayer = (videoId:string, playerId:string) => {
	//@ts-ignore

	nextTick(() => {
		player.value = new YT.Player(`${playerId}`, {
			height: '390',
			width: '640',
			videoId: videoId,
			playerVars: {
				'playsinline': 1,
				'controls': 0,
				'showinfo': 0
			},
			events: {
				'onReady': playVideo,
			}
		});
	})
}

onMounted(() => {
	injectYoutubePlayerAPIScript();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (isDesktopBreakpoint.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["hotspot-content__media-stage", { 'hotspot-content__media-stage--video': activeElement?.type === `video`}])
            }, [
              (activeElement?.type === `video`)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: activeElement?.passedValue,
                    alt: activeElement?.alt,
                    class: "hotspot-content__stage-image"
                  }, null, 8 /* PROPS */, _hoisted_7))
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(), _createBlock(_unref(Swiper), {
            modules: modules,
            breakpoints: swiperOptions,
            "slides-per-view": 3,
            "space-between": 10,
            allowSlidePrev: true,
            allowSlideNext: true,
            ref_key: "swiperInstance",
            ref: swiperInstance,
            preloadImages: true,
            key: swiperKey.value,
            onInit: swiperInit,
            onBreakpoint: breakpointChange,
            onSlideChange: slideChange,
            navigation: { prevEl: swiperLeft.value, nextEl: swiperRight.value }
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(combinedHotspotImagesAndVideos.value, (el, index) => {
                return (_openBlock(), _createBlock(_unref(SwiperSlide), {
                  key: index,
                  class: _normalizeClass({ 'active-element': index === activeSwiperSlideIndex.value })
                }, {
                  default: _withCtx(() => [
                    (el.hasOwnProperty('YouTubeID'))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (isDesktopBreakpoint.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("span", {
                                  class: "fa-solid fa-circle-play hotspot-content__play type-video",
                                  onClick: ($event: any) => (setActiveElement(el, index))
                                }, null, 8 /* PROPS */, _hoisted_9),
                                _createElementVNode("img", {
                                  src: `https://img.youtube.com/vi/${el.YouTubeID}/mqdefault.jpg`,
                                  alt: `youtubevideo-${el.YouTubeID}`,
                                  class: "hotspot-content__slider-image hotspot-content__slider-image--video-preview type-video",
                                  onClick: ($event: any) => (setActiveElement(el, index))
                                }, null, 8 /* PROPS */, _hoisted_10)
                              ], 64 /* STABLE_FRAGMENT */))
                            : (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                        ], 64 /* STABLE_FRAGMENT */))
                      : (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: el.ImageUrl,
                          alt: el.AltText,
                          class: "hotspot-content__slider-image type-image",
                          onClick: ($event: any) => (setActiveElement(el, index))
                        }, null, 8 /* PROPS */, _hoisted_14))
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class"]))
              }), 128 /* KEYED_FRAGMENT */)),
              _createElementVNode("div", {
                class: "hotspot-content__prev",
                ref_key: "swiperLeft",
                ref: swiperLeft
              }, _hoisted_16, 512 /* NEED_PATCH */),
              _createElementVNode("div", {
                class: "hotspot-content__next",
                ref_key: "swiperRight",
                ref: swiperRight
              }, _hoisted_18, 512 /* NEED_PATCH */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["navigation"]))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      (__props.hotspotItem.DisplayTitle)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "hotspot-content__display-title animate__animated animate__fadeIn",
            innerHTML: __props.hotspotItem.DisplayTitle
          }, null, 8 /* PROPS */, _hoisted_20))
        : _createCommentVNode("v-if", true),
      (__props.hotspotItem?.TitleImages?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.hotspotItem?.TitleImages, (logo) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("img", {
                  src: logo.ImageUrl,
                  alt: logo.AltText,
                  class: "hotspot-content__logo-image"
                }, null, 8 /* PROPS */, _hoisted_23)
              ]))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true),
      (__props.hotspotItem?.Description)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "hotspot-content__description animate__animated animate__fadeIn",
            innerHTML: __props.hotspotItem?.Description
          }, null, 8 /* PROPS */, _hoisted_24))
        : _createCommentVNode("v-if", true),
      (__props.hotspotItem?.CallToActionUrl)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _createElementVNode("div", {
              class: "btn btn-primary",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (goToUrl(__props.hotspotItem.CallToActionUrl, __props.hotspotItem.CallToActionNewWindow)), ["prevent"]))
            }, [
              _createTextVNode(_toDisplayString(__props.hotspotItem.CallToActionText), 1 /* TEXT */),
              (__props.hotspotItem.CallToActionNewWindow)
                ? (_openBlock(), _createElementBlock("span", _hoisted_26))
                : _createCommentVNode("v-if", true)
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("span", {
          class: _normalizeClass(["fa-solid fa-chevron-left hotspot-content__pager-left", { 'disabled': __props.index === 0 }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (goToPreviousIndex(__props.index)))
        }, null, 2 /* CLASS */),
        _createTextVNode(_toDisplayString(zeroInFront(__props.index+1)) + " of " + _toDisplayString(zeroInFront(__props.placementsLength)), 1 /* TEXT */),
        _createElementVNode("span", {
          class: _normalizeClass(["fa-solid fa-chevron-right hotspot-content__pager-right", { 'disabled': __props.index + 1 >= __props.placementsLength }]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (goToNextIndex(__props.index)))
        }, null, 2 /* CLASS */)
      ])
    ])
  ]))
}
}

})